(function () {
  'use strict';
  var T = window.theme || {};
  function $(s, r) { return (r || document).querySelector(s); }

  var bar, toggle, input, results, form, timer, controller, lastQuery = '';

  function openBar() {
    if (!bar) return;
    bar.hidden = false;
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (input) input.focus();
  }
  function closeBar() {
    if (!bar) return;
    bar.hidden = true;
    if (results) { results.hidden = true; results.innerHTML = ''; }
    if (input) input.setAttribute('aria-expanded', 'false');
    if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
  }

  function search(q) {
    if (!T.predictiveSearch || !T.routes || !T.routes.predictiveSearch) return;
    if (q.length < 2) { results.hidden = true; results.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }
    if (q === lastQuery) return;
    lastQuery = q;
    if (controller) controller.abort();
    controller = ('AbortController' in window) ? new AbortController() : null;
    var url = T.routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page,article&resources[limit]=4&section_id=predictive-search';
    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error('search'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = $('.pred-inner', doc);
        if (inner) {
          results.innerHTML = inner.outerHTML;
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        } else {
          results.hidden = true;
        }
      })
      .catch(function (err) { if (err && err.name === 'AbortError') return; results.hidden = true; });
  }

  function init() {
    bar = $('[data-search-bar]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    toggle = $('[data-search-toggle]');
    input = $('[data-predictive-input]', bar);
    results = $('[data-predictive-results]', bar);
    form = $('[data-search-form]', bar);

    if (toggle) toggle.addEventListener('click', function (e) {
      e.preventDefault();
      bar.hidden ? openBar() : closeBar();
    });
    var closeBtn = $('[data-search-close]', bar);
    if (closeBtn) closeBtn.addEventListener('click', closeBar);

    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        timer = setTimeout(function () { search(q); }, 220);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          var first = $('a', results);
          if (first && !results.hidden) { e.preventDefault(); first.focus(); }
        }
      });
    }
    if (results) {
      results.addEventListener('keydown', function (e) {
        var links = Array.prototype.slice.call(results.querySelectorAll('a'));
        var i = links.indexOf(document.activeElement);
        if (e.key === 'ArrowDown' && i < links.length - 1) { e.preventDefault(); links[i + 1].focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); if (i > 0) links[i - 1].focus(); else if (input) input.focus(); }
      });
    }
    bar.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); closeBar(); } });
    document.addEventListener('click', function (e) {
      if (!bar.hidden && !e.target.closest('[data-search-bar]') && !e.target.closest('[data-search-toggle]')) {
        if (results) results.hidden = true;
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { var b = $('[data-search-bar]'); if (b) delete b.dataset.ready; init(); });
})();
